import { useState, useEffect } from "react";
import { fetchLevels } from "../services/fetchLevels";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

function useFetchLevels() {
  const [levels, setLevels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [title, setTitle] = useState(true);
  const { auth, setCommonWarning, breadcrumbs } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const loadLevels = async () => {
      try {
        const subject =
          breadcrumbs.find((item) => item.path === "/levels")?.id || null;
        const title =
          breadcrumbs.find((item) => item.path === "/levels")?.title || null;
        setTitle(title);
        const data = await fetchLevels(auth.token, subject);
        // setLevels(data);
        if (data.status === 200) {
          const fnldata = data.data.map((level) => ({
            id: level.id,
            name: level.level,
            is_purchased: level.is_purchased,
            percentage: level.percentage,
          }));
          setLevels(fnldata);
        } else if (data.status === 400) {
          setCommonWarning(data.message);
        } else if (data.status === 401) {
          navigate("/login");
          return []; // return empty if unauthorized
        }
        setLoading(false);
      } catch (error) {
        console.error("Error fetching levels:", error);
      }
    };
    loadLevels();
  }, [auth, breadcrumbs, setCommonWarning]);

  return [levels, loading, title];
}

export default useFetchLevels;
